import React from "react";
import { ShieldCheck, FileText, Camera, Star } from "lucide-react";

// Only verifiable commitments. No volumes, percentages or ratings that the
// business cannot document publicly.
const COUNTERS = [
  { id: "h24", icon: ShieldCheck, value: "H24", labelKey: "trust.counter_h24" },
  { id: "quote", icon: FileText, value: "Scritto", labelKey: "trust.counter_quote" },
  { id: "report", icon: Camera, value: "Report", labelKey: "trust.counter_report" },
  { id: "reviews", icon: Star, value: "Google", labelKey: "trust.counter_reviews" },
];

export function HomeTrustCounters({ t, lang = "it" }) {
  const resolve = (id, value) => ({ value, label: null });
  return (
    <section
      className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14"
      data-testid="home-trust-counters"
      aria-label="Trust counters"
    >
      <div className="flex items-baseline justify-between flex-wrap gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">
          {t("trust.title")}
        </h2>
        <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-prose">
          {t("trust.sub")}
        </p>
      </div>
      <div className="mt-5 grid grid-cols-2 lg:grid-cols-4 gap-3">
        {COUNTERS.map(({ id, icon: Icon, value: rawValue, labelKey }) => {
          const { value, label } = resolve(id, rawValue);
          return (
          <div
            key={id}
            className="relative overflow-hidden rounded-xl border border-[hsl(var(--border))] bg-white p-4 sm:p-5 noise-bg"
            data-testid={`trust-counter-${id}`}
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[hsl(var(--brand-aqua))]/10 text-[hsl(var(--brand-aqua))]">
              <Icon className="h-5 w-5" />
            </span>
            <div className="mt-3 text-3xl sm:text-4xl font-semibold text-[hsl(var(--brand-navy))] tracking-tight">
              {value}
            </div>
            <div className="mt-1 text-xs sm:text-sm text-[hsl(var(--muted-foreground))] leading-snug">
              {label || t(labelKey)}
            </div>
          </div>
          );
        })}
      </div>
    </section>
  );
}

export default HomeTrustCounters;
